module.exports = __webpack_public_path__ + "files/236d17296c79b7d91ae698df80a68b5a.png";